import React, { useState, useEffect } from "react";

import Axios from "axios";

import {
    MDBBtn,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBTooltip,
} from "mdb-react-ui-kit";
import { Link, useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload, faEye, faPen, faTrash} from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";
import Moment from 'moment';
import {backendPathAuth, backendPathCustomers, backendPathTasks, tariffs, viewableMimeTypes} from "../Constants";
import Uploader from "../components/Uploader";
import {calcAge} from "../functions/date";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";
import {canViewByExtension} from "../functions/visibility";


function Customer() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(0);
    const [street, setStreet] = useState("");
    const [houseNumber, setHouseNumber] = useState(0);
    const [zip, setZIP] = useState(0);
    const [city, setCity] = useState("");
    const [birthday, setBirthday] = useState(Moment().format('YYYY-MM-DD'));
    const [insurance, setInsurance] = useState("");
    const [degreeOfCare, setDegreeOfCare] = useState(0);
    const [secondPerson, setSecondPerson] = useState(0);
    const [name2, setName2] = useState("");
    const [surname2, setSurname2] = useState("");
    const [phoneNumber2, setPhoneNumber2] = useState(0);
    const [street2, setStreet2] = useState("");
    const [houseNumber2, setHouseNumber2] = useState(0);
    const [zip2, setZIP2] = useState(0);
    const [city2, setCity2] = useState("");
    const [birthday2, setBirthday2] = useState(Moment().format('YYYY-MM-DD'));
    const [insurance2, setInsurance2] = useState("");
    const [degreeOfCare2, setDegreeOfCare2] = useState(0);
    const [thirdPerson, setThirdPerson] = useState(0);
    const [name3, setName3] = useState("");
    const [surname3, setSurname3] = useState("");
    const [phoneNumber3, setPhoneNumber3] = useState(0);
    const [relation3, setRelation3] = useState("");
    const [escalation, setEscalation] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [inactive, setInactive] = useState(0);
    const [tariff, setTariff] = useState(0);
    const [partner, setPartner] = useState("");
    const [officeEmployeeFirstName, setOfficeEmployeeFirstName] = useState("");
    const [officeEmployeeLastName, setOfficeEmployeeLastName] = useState("");

    const [tasks, setTasks] = useState([]);
    const [files, setFiles] = useState([]);
    const [deletionPopupVisible, setDeletionPopupVisible] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    
    const getCustomer = () => {
        Axios.get(backendPathCustomers+"customer.php?id="+id).then((response) => {

            if (response.data.length === 0) {
                navigate("/404");
            }

            const customer = response.data[0];

            setName(customer.FirstName);
            setSurname(customer.LastName);
            setPhoneNumber(customer.PhoneNumber);
            setStreet(customer.Street);
            setHouseNumber(customer.HouseNumber);
            setZIP(customer.ZIP);
            setCity(customer.City);
            setBirthday(customer.Birthday);
            setInsurance(customer.Insurance);
            setDegreeOfCare(customer.DegreeOfCare);
            setSecondPerson(customer.SecondPerson);
            setName2(customer.FirstName2);
            setSurname2(customer.LastName2);
            setPhoneNumber2(customer.PhoneNumber2);
            setStreet2(customer.Street2);
            setHouseNumber2(customer.HouseNumber2);
            setZIP2(customer.ZIP2);
            setCity2(customer.City2);
            setBirthday2(customer.Birthday2);
            setInsurance2(customer.Insurance2);
            setDegreeOfCare2(customer.DegreeOfCare2);
            setThirdPerson(customer.ThirdPerson);
            setName3(customer.FirstName3);
            setSurname3(customer.LastName3);
            setPhoneNumber3(customer.PhoneNumber3);
            setRelation3(customer.Relation3);
            setEscalation(customer.Escalations);
            setAnnotation(customer.Annotation);
            setInactive(customer.Inactive);
            setTariff(customer.Tariff);
            setPartner(customer.PartnerName);
            setOfficeEmployeeFirstName(customer.OfficeEmployeeFirstName);
            setOfficeEmployeeLastName(customer.OfficeEmployeeLastName)
        });
    };

    const getTasks = () => {
        Axios.get(`${backendPathTasks}tasks-of-customer.php?id=${id}`).then((response) => {
            setTasks(response.data);
            console.log(response.data);
        });
    };

    const getFiles = () => {
        Axios.get(`${backendPathCustomers}customer-files.php?id=${id}`).then((response) => {
            setFiles(response.data);
            console.log(files);
        });
    }

    const toggleShow = () => setDeletionPopupVisible(!deletionPopupVisible);

    const deleteCustomer = () => {
        Axios.get(`${backendPathCustomers}delete-customer.php?id=${id}`).then((response) => {
            navigate("/customers",);
        });
    };

    const deleteFile = (filename) => {
        Axios.get(`${backendPathCustomers}customer-delete-file.php?id=${id}&name=${filename}`).then((response) => {
            console.log("deleted " + filename);
            getFiles();
        });
    };

    const editCustomer = () => {
        navigate("/edit-customer/" + id);
    };

    const openFileInNewTab = async (filename) => {

        try {
            const response = await fetch(`${backendPathCustomers}get-customer-file.php?id=${id}&filename=${encodeURIComponent(filename)}`, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error('File download failed!');
            }

            const blob = await response.blob();
            const fileURL = URL.createObjectURL(blob);
            console.log("file success");

            // Open in new tab
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL); // Optional cleanup
        } catch (error) {
            console.error('Error opening file:', error);
        }
    };

    const downloadFile = async (filename) => {
        try {
            const response = await fetch(`${backendPathCustomers}get-customer-file.php?id=${id}&filename=${encodeURIComponent(filename)}`, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error('File download failed!');
            }

            const blob = await response.blob();
            saveAs(blob, filename);
        } catch (error) {
            console.error('Error opening file:', error);
        }
    }

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getCustomer();
    }, [id])

    useEffect(() => {
        getTasks();
    }, [name])

    useEffect(() => {
        getFiles();
    }, [name]);


    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
        <div className='main'>
            <div className='header'>
                <h2>{name} {surname} {inactive ? "(inaktiv)" : ""}</h2>
                <div className='btns'>
                    <MDBBtn className="btn delete" onClick={toggleShow}>
                        <FontAwesomeIcon className='btn-icon' icon={faTrash} />
                        Löschen
                    </MDBBtn>
                    <MDBBtn className="btn" onClick={editCustomer}>
                        <FontAwesomeIcon className='btn-icon' icon={faPen} />
                        Bearbeiten
                    </MDBBtn>
                    <MDBBtn className="btn" onClick={() => {navigate(`/new-task?customerId=${id}`)}}>
                        Einsatz planen
                    </MDBBtn>
                </div>
            </div>

            <MDBTable align='middle'>
                <tbody>
                <tr>
                    <th>Adresse</th>
                    <td>{street} {houseNumber}, {zip} {city}</td>
                </tr>
                <tr>
                    <th>Alter</th>
                    <td>{calcAge(birthday)}</td>
                </tr>
                <tr>
                    <th>Geburtsdatum</th>
                    <td>{Moment(birthday).format("DD.MM.YYYY")}</td>
                </tr>
                <tr>
                    <th>Telefon</th>
                    <td>{phoneNumber}</td>
                </tr>
                <tr>
                    <th>Partner</th>
                    <td>{partner ? partner : "-"}</td>
                </tr>
                <tr>
                    <th>Paket</th>
                    <td>{tariff !== null ? tariffs[tariff].label : "-"}</td>
                </tr>
                <tr>
                    <th>Zuständiger Mitarbeiter</th>
                    <td>{officeEmployeeFirstName ? officeEmployeeFirstName + " " + officeEmployeeLastName : "-"}</td>
                </tr>
                <tr>
                    <th>Pflegekasse</th>
                    <td>{insurance}</td>
                </tr>
                <tr>
                    <th>Pflegegrad</th>
                    <td>{degreeOfCare}</td>
                </tr>

                {secondPerson ?
                    <tr>
                        <th>zweite zu betreuende Person</th>
                        <MDBTable align='middle' borderless>
                            <table>
                                <tr>
                                    <th>Vorname</th>
                                    <td>{name2}</td>
                                </tr>
                                <tr>
                                    <th>Nachname</th>
                                    <td>{surname2}</td>
                                </tr>
                                <tr>
                                    <th>Telefon</th>
                                    <td>{phoneNumber2}</td>
                                </tr>
                                <tr>
                                    <th>Adresse</th>
                                    <td>{street2} {houseNumber2}, {zip2} {city2}</td>
                                </tr>
                                <tr>
                                    <th>Alter</th>
                                    <td>{calcAge(birthday2)}</td>
                                </tr>
                                <tr>
                                    <th>Geburtsdatum</th>
                                    <td>{Moment(birthday2).format("DD.MM.YYYY")}</td>
                                </tr>
                                <tr>
                                    <th>Pflegekasse</th>
                                    <td>{insurance2}</td>
                                </tr>
                                <tr>
                                    <th>Pflegegrad</th>
                                    <td>{degreeOfCare2}</td>
                                </tr>
                            </table>
                        </MDBTable>
                    </tr>
                    : null}

                {thirdPerson ?
                    <tr>
                        <th>zweite Person im Haushalt</th>
                        <MDBTable align='middle' borderless>
                            <table>
                                <tr>
                                    <th>Vorname</th>
                                    <td>{name3}</td>
                                </tr>
                                <tr>
                                    <th>Nachname</th>
                                    <td>{surname3}</td>
                                </tr>
                                <tr>
                                    <th>Telefon</th>
                                    <td>{phoneNumber3}</td>
                                </tr>
                                <tr>
                                    <th>Beziehung</th>
                                    <td>{relation3}</td>
                                </tr>
                            </table>
                        </MDBTable>
                    </tr>
                    : null}

                <tr>
                    <th>Eskalationen</th>
                    <td>{escalation ? escalation : '-'}</td>
                </tr>
                <tr>
                    <th>Notizen</th>
                    <td>{annotation ? annotation : '-'}</td>
                </tr>
                </tbody>
            </MDBTable>

            <h3>Dateiablage</h3>

            {
                files.length ?
                    <MDBTable align='middle'>
                    <MDBTableHead>
                        <tr>
                            <th scope='col'>Dateiname</th>
                            <th scope='col'>Änderungsdatum</th>
                            <th scope='col'></th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {files.map((val, key) => {
                            return (
                                <tr key={key}>
                                    <td>{val.name}</td>
                                    <td>{val.date}</td>
                                    <td style={{textAlign: "right"}}>
                                        <MDBTooltip tag='a' title="ansehen">
                                            <FontAwesomeIcon
                                                hidden={!canViewByExtension(val.name)}
                                                className='btn-icon trash-btn' icon={faEye} onClick={
                                                () => {
                                                    openFileInNewTab(val.name).then(r => console.log(r));
                                                }}/>
                                        </MDBTooltip>

                                        <MDBTooltip tag='a' title="herunterladen">
                                            <FontAwesomeIcon className='btn-icon trash-btn ms-4' icon={faDownload}
                                                             onClick={() => {
                                                                 downloadFile(val.name).then(r => console.log(r));
                                                             }}/>
                                        </MDBTooltip>

                                        <MDBTooltip tag='a' title="löschen">
                                            <FontAwesomeIcon className='btn-icon trash-btn ms-4' icon={faTrash}
                                                             onClick={() => {
                                                                 deleteFile(val.name);
                                                             }}/>
                                        </MDBTooltip>
                                    </td>
                                </tr>
                            );
                        })}
                    </MDBTableBody>
                    </MDBTable>
                    : null
            }

            <p className="input-label" style={{marginTop: 32}}>neue Dateien hochladen</p>
            <Uploader personalId={id} personType={"customer"} refresh={getFiles} onClick={getFiles}></Uploader>

            <h3>Einsatzhistorie</h3>

            <MDBTable align='middle'>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>Zeitraum</th>
                        <th scope='col'>Betreuungskraft</th>
                        <th scope='col'>Anmerkung</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {tasks.map((val, key) => {
                        return (
                            <tr key={key}>
                                <td>{Moment(val.StartDate).format("DD.MM.YYYY")} - {Moment(val.EndDate).format("DD.MM.YYYY")}</td>
                                <td>
                                    <Link to={"/employee/"+val.EmployeeID}>{val.FirstNameE} {val.LastNameE}</Link>
                                </td>
                                <td>{val.annotation? val.annotation : "-"}</td>
                            </tr>
                        );
                    })}
                </MDBTableBody>
            </MDBTable>

            <MDBModal show={deletionPopupVisible} setShow={setDeletionPopupVisible} tabIndex="-1">
                <MDBModalDialog>
                <MDBModalContent>
                    <MDBModalHeader>
                    <MDBModalTitle>{name} {surname} löschen</MDBModalTitle>
                    <MDBBtn
                        className="btn-close"
                        color="none"
                        onClick={toggleShow}
                    ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>Wenn der Kunde gelöscht wird, werden auch alle Ihn betreffenden Einsätze gelöscht.</MDBModalBody>

                    <MDBModalFooter>
                    <MDBBtn className="btn-light" onClick={toggleShow}>
                        Abbrechen
                    </MDBBtn>
                    <MDBBtn onClick={deleteCustomer}>Löschen</MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

        </div>
        </>
    );
}

export default Customer;